import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Footer({ showLinks = true, showSocial = true }) {
  const { t } = useTranslation()
  const shareUrl = typeof window !== 'undefined' ? window.location.href : ''
  const shareText = 'Anytime Tracker'
  const encodedShareUrl = encodeURIComponent(shareUrl)
  const encodedShareText = encodeURIComponent(shareText)
  const encodedLineShareText = encodeURIComponent(`${shareText} ${shareUrl}`)
  const shareLinks = [
    {
      label: 'X',
      href: `https://twitter.com/intent/tweet?text=${encodedShareText}&url=${encodedShareUrl}`,
      className: 'border-gray-700 bg-black text-white hover:border-white/60 hover:bg-gray-950',
      buttonClassName: 'h-11 w-11',
      iconClassName: 'h-6 w-6',
      icon: (
        <path d="M13.9 10.5 20.8 2h-1.6l-6 7.4L8.4 2H3l7.2 11.1L3 22h1.6l6.3-7.7 5 7.7h5.4l-7.4-11.5Zm-2.2 2.7-.7-1.1L5.2 3.3h2.4l4.7 7.1.7 1.1 6.1 9.2h-2.4l-5-7.5Z" />
      )
    },
    {
      label: 'Threads',
      href: `https://www.threads.net/intent/post?text=${encodedShareText}%20${encodedShareUrl}`,
      className: 'border-gray-600 bg-white text-black hover:border-white hover:bg-gray-100',
      buttonClassName: 'h-11 w-11',
      iconClassName: 'h-6 w-6',
      icon: (
        <path d="M12.2 2C6.6 2 3.4 5.6 3.4 12.1c0 6.2 3.3 9.9 8.9 9.9 4.9 0 8.2-2.9 8.2-7.1 0-3-1.6-5-4.6-5.9-.5-3-2.3-4.6-5.1-4.6-2.1 0-3.8.9-4.9 2.6l1.8 1.3c.8-1.2 1.8-1.8 3.1-1.8 1.5 0 2.5.8 2.9 2.2-.5-.1-1.1-.1-1.7-.1-3.4 0-5.4 1.6-5.4 4.1 0 2.3 1.8 3.9 4.5 3.9 2.9 0 4.8-1.8 5-4.8 1.5.7 2.2 1.8 2.2 3.2 0 2.8-2.3 4.8-5.9 4.8-4.3 0-6.6-2.8-6.6-7.7 0-5.2 2.3-7.9 6.5-7.9 2.8 0 4.6 1.1 5.8 3.6l2-1C18.6 3.5 16 2 12.2 2Zm-.9 12.5c-1.4 0-2.3-.7-2.3-1.8 0-1.3 1.1-2 3.1-2 .7 0 1.3.1 1.9.2v.4c0 2-1 3.2-2.7 3.2Z" />
      )
    },
    {
      label: 'LINE',
      href: `https://line.me/R/share?text=${encodedLineShareText}`,
      className: 'border-[#06c755] bg-[#06c755] text-white hover:border-[#19d86a] hover:bg-[#19d86a]',
      buttonClassName: 'h-11 w-11',
      iconClassName: 'h-7 w-7',
      icon: (
        <path d="M12 3C6.5 3 2 6.7 2 11.2c0 4 3.6 7.4 8.4 8.1.3.1.8.2.9.5.1.3.1.7 0 1l-.2.9c-.1.3-.3 1.1.9.6 1.2-.5 6.4-3.8 8.7-6.5 1.6-1.7 2.3-3.2 2.3-4.7C22 6.7 17.5 3 12 3Zm-3.8 10.7H6.3c-.3 0-.5-.2-.5-.5V9c0-.3.2-.5.5-.5s.5.2.5.5v3.7h1.4c.3 0 .5.2.5.5s-.2.5-.5.5Zm2.2-.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5V9c0-.3.2-.5.5-.5s.5.2.5.5v4.2Zm4.6 0c0 .2-.1.4-.3.5-.1 0-.2.1-.2.1-.2 0-.3-.1-.4-.2l-2.1-2.8v2.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5V9c0-.2.1-.4.3-.5.2-.1.5 0 .6.2l2.1 2.8V9c0-.3.2-.5.5-.5s.5.2.5.5v4.2Zm3.3-2.6c.3 0 .5.2.5.5s-.2.5-.5.5h-1.4v1.1h1.4c.3 0 .5.2.5.5s-.2.5-.5.5h-1.9c-.3 0-.5-.2-.5-.5V9c0-.3.2-.5.5-.5h1.9c.3 0 .5.2.5.5s-.2.5-.5.5h-1.4v1.1h1.4Z" />
      )
    }
  ]

  return (
    <footer className="mt-12 pt-8 border-t border-gray-800 text-center text-xs text-gray-500">
      {showLinks && (
        <div className="flex justify-center gap-3 mb-6">
          <a href="/terms_of_service" className="hover:text-white transition-colors">{t('terms_of_service')}</a>
          <a href="/privacy_policy" className="hover:text-white transition-colors">{t('privacy_policy')}</a>
          <a href="/operator_info" className="hover:text-white transition-colors">{t('operator_info')}</a>
        </div>
      )}

      {showSocial && (
        <div className="flex items-center justify-center gap-3 mb-4">
          {shareLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${link.label}で共有`}
              title={`${link.label}で共有`}
              className={`flex ${link.buttonClassName || 'h-9 w-9'} items-center justify-center rounded-full border shadow-sm transition-colors ${link.className}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={link.iconClassName || 'h-[18px] w-[18px]'}
                aria-hidden="true"
              >
                {link.icon}
              </svg>
            </a>
          ))}
        </div>
      )}

      <div className="flex items-center justify-center gap-2 mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-4 h-4 text-orange-500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6.5 6.5l11 11" />
          <path d="M21 21l-1-1" />
          <path d="M3 3l1 1" />
          <path d="M18 22l4-4" />
          <path d="M2 6l4-4" />
          <path d="M3 10l7-7" />
          <path d="M14 21l7-7" />
        </svg>
        <span className="font-bold text-gray-400">Anytime Tracker</span>
      </div>
      <p>© {new Date().getFullYear()} Anytime Tracker. All rights reserved.</p>
    </footer>
  )
}
